import $ from 'jquery';
import module from 'module';
import _ from 'lodash';

import './lookup-item.style.less';
import templateUrl from './lookup-item.template.html';

class LookupItemComponent {
  constructor(http, $location, authentication, branchService, requestFormatter, pawnItemTypeCache, confirmation,
              command, pawnItemCache, $route) {
    this.http = http;
    this.$location = $location;
    this.authentication = authentication;
    this.branchService = branchService;
    this.requestFormatter = requestFormatter;
    this.pawnItemTypeCache = pawnItemTypeCache;
    this.confirmation = confirmation;
    this.command = command;
    this.pawnItemCache = pawnItemCache;
    this.$route = $route;
  }

  async $onInit() {
    [this.pawnItemTypes, this.branches] = await Promise.all([this.pawnItemTypeCache.toPromise(), this.branchService.toPromise()]);
    this.resetSearchParams();
    this.searchResults = null;
    this.searchPerformed = false;
    this.multiSearch = false
    this.hideItemLookup = false;
    this.items = [];
    this.itemIdsSet = new Set();
    this.cancelUrl = '/dashboard/lookup-item';
  }

  resetSearchParams() {
    this.searchParams = {
      trackingCode: null
    };
  }

  getTypeLabel(typeId) {
    const type = _.find(this.pawnItemTypes, {id: typeId});
    return type && type.name ? type.name : '-';
  }

  validSearchRequest() {
    return this.searchParams.trackingCode != null;
  }

  emptyResults() {
    return this.searchResults !== null && this.searchResults.length === 0;
  }

  showResults() {
    return this.searchPerformed && !this.emptyResults();
  }

  nullifyParams(searchParams) {
    _.each(searchParams, function (value, key) {
      if (value != null && $.trim(value) == '') {
        searchParams[key] = null;
      }
    });
  }

  async search() {
    this.searchResults = await this.searchForItem();

    if (!this.searchResults || this.searchResults.length !== 1) {
      console.error('results', this.searchResults);
      return;
    }

    const item = this.searchResults[0];
    if (!this.multiSearch) {
      this.openItemHistory(item.id);
      return;
    }

    if (this.itemIdsSet.has(item.id)) {
      return;
    }

    this.addItem(item);
    this.validateItemBranches();
  }

  validateItemBranches() {
    const uniqueBranchIds = [...new Set(this.items.map(i => i.branchId))];
    this.differentBranchesDetected = uniqueBranchIds.length > 1;
  }

  async searchForItem() {
    this.nullifyParams(this.searchParams);
    const queryParams = this.requestFormatter.convertToQueryParams(this.searchParams);

    const searchResults = await this.http.get(`/products/pawns/items/history${queryParams}`, {nxLoaderText: 'Searching for item...'})
      .toPromise();

    this.searchPerformed = true;
    this.resetSearchParams();

    return searchResults;
  }

  addItem(item) {
    this.items.push({
      ...item,
      categoryLabel: this.getTypeLabel(item.categoryId),
      typeLabel: this.getTypeLabel(item.typeId),
      branchName: this.branches.find(b => b.id === item.branchId).name
    })
    this.itemIdsSet.add(item.id);
  }

  buildRedirectUrl(itemId) {
    if (!this.authentication.permissions['LOOKUP_ITEM_READ']) {
      return;
    }
    return `/dashboard/lookup-item/${itemId}`;
  }

  openItemHistory(itemId) {
    this.$location.path(this.buildRedirectUrl(itemId));
  }

  switchMultiSearch() {
    this.multiSearch = !this.multiSearch;
  }

  hasItems() {
    return this.items && this.items.length > 0;
  }

  itemClicked(item, $event) {
    $event.stopPropagation();
    this.selectedItemId = item.id;
  }

  hideInlinePanel() {
    this.selectedItemId = null;
  }

  removeItem(index) {
    const removedItems = this.items.splice(index, 1);
    this.itemIdsSet.delete(removedItems[0].id);
    this.validateItemBranches();
  }

  showTransferToBranchPage() {
    this.hideItemLookup = true;
    this.transferToBranchPageEnabled = true;
    this.itemIds = this.items.map(i => i.id);
  }

  showTransferToHeadOfficePage() {
    this.hideItemLookup = true;
    this.transferToHeadOfficePageEnabled = true;
    this.itemIds = this.items.map(i => i.id);
  }

  isTransferEnabled() {
    return !this.differentBranchesDetected && this.items.every(i => ['NEW', 'UNSOLD', 'PENDING'].includes(i.status));
  }

  isConfirmEnabled() {
    return !this.differentBranchesDetected && this.items.every(i => ['TRANSFERRING', 'WITHDRAWN'].includes(i.status));
  }

  async confirmTransfer() {
    const confirmed = await this.confirmation(`Do you confirm these items are received by the branch?`);
    if (!confirmed) {
      return;
    }

    const response = await this.command.execute('ConfirmTransferStockItems', {itemIds: this.items.map(i => i.id)}).toPromise();
    if (response.approvalRequired) {
      return;
    }

    this.pawnItemCache.evict();
    this.$route.reload();
  }
}

module.component('lookupItem', {
  templateUrl: templateUrl,
  controller: LookupItemComponent
});
